module.exports = __webpack_public_path__ + "img/bg-device.ec2e549e.png";